import type { ComponentType, ReactNode, SVGProps } from 'react';

/**
 * The small round icon in a stat tile's corner: what the number is about, at a
 * glance, before the label is read. `tone` follows the tile's state, so a tile
 * that needs a look is red in its icon as well as its edge.
 */
export function StatIcon({
  icon: Icon,
  tone = 'accent',
}: {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  tone?: 'accent' | 'danger' | 'ok' | 'muted';
}): ReactNode {
  return (
    <span className={`stat-icon stat-icon-${tone}`} aria-hidden="true">
      <Icon />
    </span>
  );
}
